import { createCrudService } from '../boot/gerdauCrudService'
import api from '../boot/api'
import { responseToOptionsInContext } from '../boot/baseApi'
import { handleError } from '../helpers/errorHandler'
const truckTractorService = createCrudService('/logisticaApi/truckTractor', api)

export default truckTractorService

truckTractorService.getTruckTractorByUserCompany = async () => {
  let result = await api.get(`/logisticaApi/truckTractor/getTruckTractorByUserCompany`)
  const data = Array.isArray(result.data.data) ? result.data.data : result.data
  return data
}

truckTractorService.getExportTruckTractorByUserCompany = async () => {
  try {
    let result = await api.get(`/logisticaApi/truckTractor/exportByCompany`, {
      responseType: 'blob'
    })
    const filename = truckTractorService.getResponseFilenameWithout(result)

    return { data: result.data, filename }
  } catch (e) {
    handleError(e)
    throw e
  }
}
truckTractorService.processValidationContext = (component, ctx, meta) => {
  responseToOptionsInContext(ctx)
  const fieldsById = _.keyBy(meta.fields, (field) => field.id)
  fieldsById.company.options = ctx.companyOptions
}